<ng-container *ngIf="currentOrganization$ | async as currentOrganization; else noOrganizationSelected">
  <div *ngIf="currentOrganization.demoMode" class="alert alert-warning rounded-0 border-0 m-0">
    <span class="material-icons align-middle">flight</span>
    <span class="align-middle ms-3"
      >Organisationen är just nu i demoläge. Det innebär att du är mottagare av all epost som skickas till deltagarna.</span
    >
  </div>
  <ng-container *ngIf="currentActivity$ | async as currentActivity; else noActivity">
    <app-activity-navigation></app-activity-navigation>
  </ng-container>

  <ng-template #noActivity>
    <app-organization-navigation></app-organization-navigation>
  </ng-template>
</ng-container>

<ng-template #noOrganizationSelected>
  <app-home-navigation></app-home-navigation>
</ng-template>

<app-toast-container></app-toast-container>
<app-confirm-dialog></app-confirm-dialog>
<div class="container-fluid pt-2 pt-lg-4 pb-5">
  <div>
    <router-outlet></router-outlet>
  </div>

  <div *ngIf="(account$ | async) === undefined">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-4 offset-lg-4 text-center mt-4">
          <img src="/assets/vertical-black.png" style="width: 300px" alt="Klubbavgift.se's logo" />
          <h4 class="mt-3">Laddar klubbavgift.se...</h4>
          <div class="progress mb-3">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated bg-dark"
              role="progressbar"
              aria-valuenow="100"
              aria-valuemin="0"
              aria-valuemax="100"
              style="width: 100%"></div>
          </div>
          <small class="text-muted"
            >Loggar in på ditt konto, ibland tar det lite längre tid så här i början när systemet är nytt. Men snart så!</small
          >
        </div>
      </div>
    </div>
  </div>
</div>
